import { render, staticRenderFns } from "./Modulecreator.vue?vue&type=template&id=2ab46dc6&"
import script from "./Modulecreator.vue?vue&type=script&lang=js&"
export * from "./Modulecreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports